import React, {Component} from "react"
import PropTypes from "prop-types"
import {AgendaDateAsDay} from "../../../module/Dates"
import "./ManageAgenda.css"
import AgendaDay from "../AgendaDay"
import Icon from "../../atoms/Icon"

import ManageAgendaPeople from "./ManageAgendaPeople"
import ManageAgendaItems from "./ManageAgendaItems"
import ManageAgendaAccommodation from "./ManageAgendaAccommodation"
import Button from '../../atoms/Button';
import LoadingIndicator from '../../atoms/LoadingIndicator';

class ManageAgenda extends Component {
  render() {
    const that = this
    const {
      agenda,
      agendaEdit,
      people,
      cancelEditAgenda,
      addAgendaDay,
      saving,
      loading,
      uploadingImage,
    } = this.props

    const editAgenda = () => {
      this.props.editAgenda(agenda)
    }

    const saveAgenda = () => {
      this.props.saveAgenda(agendaEdit)
    }

    const agendaSorted = Object.keys(agenda)
      .map(id => {
        return {
          ...agenda[id],
          dayId: id,
        }
      })
      .sort((a, b) => {
        if (a.date === b.date) return 0
        return a.date > b.date ? 1 : -1
      })

    const agendaEditSorted = Object.keys(agendaEdit || {})
      .filter(id => {
        return agendaEdit[id] !== null
      })
      .map(id => {
        return {
          ...agendaEdit[id],
          dayId: id,
        }
      })
      .sort((a, b) => {
        if (a.date === b.date) return 0
        return a.date > b.date ? 1 : -1
      })

    if (saving) {
      return <div>Saving...</div>
    } else if (loading && !(Object.keys(agenda).length > 0)) {
      return <div> <LoadingIndicator /> </div>
    }

    return (
      <div className="ManageAgenda">
        {agendaEdit
          ? <div>
              {agendaEditSorted.map(agendaDay => {
                // debugger
                const dayId = agendaDay.dayId
                //const existingAgendaDay = agenda[dayId]
                const existingAgendaDay = agendaDay

                const removeAgendaDay = () => {
                  that.props.removeAgendaDay(dayId)
                }

                const updateAgendaDay = ev => {
                  that.props.updateAgendaDay(dayId, {
                    [ev.target.name]:
                      ev.target.type !== "checkbox"
                        ? ev.target.value
                        : ev.target.checked,
                  })
                }

                const selectAllPeople = () => {
                  that.props.setAgendaDayPeople(dayId, Object.keys(people))
                }

                const clearAllPeople = () => {
                  that.props.clearAgendaDayPeople(dayId)
                }

                if (agendaDay === null) return null

                // debugger

                return (
                  <div className="AgendaDayWrapper" key={dayId}>
                    <h1>
                      {existingAgendaDay
                        ? <span>
                            {" "}{AgendaDateAsDay(existingAgendaDay.date)} -{" "}
                            {existingAgendaDay.date}{" "}
                          </span>
                        : <span> New Day </span>}
                      <Button type="delete" onClick={removeAgendaDay}>
                        <Icon icon="trash-empty" />
                      </Button>
                    </h1>

                    <div>
                      <span className="date-label">Date</span>
                      <input
                        type="text"
                        name="date"
                        value={agendaDay.date}
                        onChange={updateAgendaDay}
                      />
                    </div>

                    <div className="AgendaDay-People">
                      <ManageAgendaPeople
                        dayId={dayId}
                        people={agendaDay.people}
                        allPeople={people}
                        selectAll={selectAllPeople}
                        clearAll={clearAllPeople}
                        addPerson={that.props.addPersonToAgendaDay}
                        removePerson={that.props.removePersonFromAgendaDay}
                      />
                    </div>

                    <div className="AgendaDay-Items">
                      <ManageAgendaItems
                        dayId={dayId}
                        items={agendaDay.items}
                        uploadingMedia={uploadingImage}
                        addItem={that.props.addAgendaItem}
                        removeItem={that.props.removeAgendaItem}
                        updateItem={that.props.updateAgendaItem}
                        uploadMedia={that.props.uploadAgendaItemMedia}
                      />
                    </div>

                    <div className="AgendaDay-Accommodation">
                      <ManageAgendaAccommodation
                        dayId={dayId}
                        accommodationRequired={agendaDay.accommodationRequired}
                        rooms={agendaDay.rooms}
                        people={people}
                        updateAccommodation={updateAgendaDay}
                        addRoom={that.props.addAgendaDayAccommodationRoom}
                        removeRoom={that.props.removeAgendaDayAccommodationRoom}
                        addPerson={that.props.addPersonToAccommodationRoom}
                        removePerson={
                          that.props.removePersonFromAccommodationRoom
                        }
                      />
                    </div>
                  </div>
                )
              })}
              <div className="controls">
                <Button onClick={addAgendaDay}>
                  <Icon icon="plus" /> Add Day
                </Button>
                <Button
                  onClick={saveAgenda}
                  disabled={uploadingImage && uploadingImage.length > 0}
                >
                  <Icon icon="floppy" /> Save
                </Button>
                <Button onClick={cancelEditAgenda}> Cancel </Button>
              </div>
            </div>
          : <div>
              {agendaSorted.map(agenda => {
                return (
                  <div className="AgendaDayWrapper" key={agenda.dayId}>
                    <h4>
                      {AgendaDateAsDay(agenda.date)} - {agenda.date}{" "}
                    </h4>
                    <AgendaDay {...agenda} />
                  </div>
                )
              })}
              <div className="controls">
                <Button onClick={editAgenda}> Edit Agenda </Button>
              </div>
            </div>}
      </div>
    )
  }
}

ManageAgenda.propTypes = {
  agenda: PropTypes.object.isRequired,
  agendaEdit: PropTypes.object,
  people: PropTypes.object,
  saving: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  uploadingImage: PropTypes.arrayOf(PropTypes.string).isRequired,
  editAgenda: PropTypes.func.isRequired,
  cancelEditAgenda: PropTypes.func.isRequired,
  saveAgenda: PropTypes.func.isRequired,

  updateAgendaDay: PropTypes.func.isRequired,
  addAgendaDay: PropTypes.func.isRequired,
  removeAgendaDay: PropTypes.func.isRequired,

  updateAgendaItem: PropTypes.func.isRequired,
  removeAgendaItem: PropTypes.func.isRequired,
  addAgendaItem: PropTypes.func.isRequired,

  removePersonFromAgendaDay: PropTypes.func.isRequired,
  addPersonToAgendaDay: PropTypes.func.isRequired,
  setAgendaDayPeople: PropTypes.func.isRequired,
  clearAgendaDayPeople: PropTypes.func.isRequired,

  addAgendaDayAccommodationRoom: PropTypes.func.isRequired,
  removeAgendaDayAccommodationRoom: PropTypes.func.isRequired,
  addPersonToAccommodationRoom: PropTypes.func.isRequired,
  removePersonFromAccommodationRoom: PropTypes.func.isRequired,
}

export default ManageAgenda



// WEBPACK FOOTER //
// ./src/component/organisms/ManageAgenda/component.js